import * as yup from 'yup'

export const generateUenRegex = () => {
  return /^(S|T)([\d]{2})([A-Z]{2})([\d]{4})([A-Z])$|^[0-9]{9}[A-Z]$|^[0-9]{8}[A-Z]$/g
}

export const generateValidationSchema = () => {
  /* Formik variables */
  const validationSchema = yup.object({
    email: yup
      .string()
      .email('Enter a valid email')
      .required('Email is required'),
    companyName: yup.string().required('Company name is required'),
    uen: yup
      .string()
      .matches(generateUenRegex(), 'Invalid UEN')
      .required('UEN is required'),
    deliveryAddress: yup
      .object()
      .shape({
        streetName: yup.string().required('Address is required'),
        buildingName: yup.string(),
        postalCode: yup
          .string()
          .matches(/^\d{6}$/, 'Invalid Postal Code')
          .required('Postal code is required'),
        unitNo: yup.string().required('Unit number is required')
      })
      .required('Delivery address is required'),
    billingAddress: yup.object().shape({
      streetName: yup.string().required('Address is required'),
      buildingName: yup.string(),
      postalCode: yup
        .string()
        .matches(/^\d{6}$/, 'Invalid Postal Code')
        .required('Postal code is required'),
      unitNo: yup.string()
    })
  })
  return validationSchema
}

export const generateDeliveryDetailsValidationSchema = () => {
  /* Formik variables */
  const validationSchema = yup.object({
    contactName: yup.string().required("Contact person's name is required"),
    contactNum: yup
      .string()
      .matches(/^[89]\d{7}$/, 'Invalid Phone Number')
      .required('Contact number is required'),
    email: yup
      .string()
      .email('Enter a valid email')
      .required('Email is required'),
    deliveryPostalCode: yup
      .string()
      .matches(/^\d{6}$/, 'Invalid Postal Code')
      .required('Postal code is required'),
    billingPostalCode: yup
      .string()
      .matches(/^\d{6}$/, 'Invalid Postal Code')
      .required('Postal code is required'),
    formattedDeliveryAddress: yup
      .string()
      .required('Delivery address is required'),
    formattedBillingAddress: yup
      .string()
      .required('Billing address is required')
  })
  return validationSchema
}

export const generateManualDeliveryValidationSchema = () => {
  /* Formik variables */
  const validationSchema = yup.object({
    deliveryCompany: yup.string().required("Delivery's name is required"),
    deliveryDate: yup.string().required('Delivery Date is required'),
    deliveryTime: yup.string().required('Time is required')
  })
  return validationSchema
}
